import parse from 'url-parse';
import { api } from '../redux/services/api';

class _DataTransfer {
	constructor() {
		return new ClipboardEvent('').clipboardData || new DataTransfer();
	}
}

const checkImageIsLoaded = async (url) => {
	console.error('checkImageIsLoaded');
	try {
		const response = await fetch(url);

		return response;
	} catch (ex) {
		console.log(ex);
	}
	return { ok: false };
};

const doGetSignedUrl = async (url, isPublic = false) => {
	const SIGNED_URL = 'private/rest/download/s3/signed/';
	const SIGNED_URL_PUBLIC = 'private/rest/download/s3/signed/public/';
	const parsedUrl = parse(url);
	const TARGET_URL = isPublic ? SIGNED_URL_PUBLIC : SIGNED_URL;
	const cdnURL = process.env.REACT_APP_CDN_URL;

	const bucket =
		process.env.REACT_APP_S3BUCKET ||
		(process.env.REACT_APP_ENV === 'live'
			? 'goalsmapper-personal-branding'
			: 'goalsmapper-personal-branding-staging');
	console.error(
		'FieldFileUploadControl doGetSignedUrl',
		process.env.REACT_APP_CDN_URL,
		process.env.REACT_APP_S3BUCKET,
		parsedUrl,
		cdnURL,
		isPublic,
		url,
	);
	if (isPublic) {
		const updatedUrl = url.replace(
			`${bucket}.s3.amazonaws.com`,
			'branding-staging.goalsmapper.com',
		);
		console.log('FieldFileUploadControl update', updatedUrl);
		return { url: updatedUrl };
	}
	const response = await api.get(
		`${TARGET_URL}?object_name=${parsedUrl?.pathname}&s3_bucket=${bucket}`,
	);
	console.log('FieldFileUploadControl doGetSignedUrl', response);
	return response.data;
};

const dataURLToBlob = (dataURL) => {
	if (typeof window !== 'undefined') {
		const BASE64_MARKER = ';base64,';
		if (dataURL.indexOf(BASE64_MARKER) === -1) {
			const parts = dataURL.split(',');
			const contentType = parts[0].split(':')[1];
			const raw = parts[1];
			return new Blob([raw], { type: contentType });
		}

		const parts = dataURL.split(BASE64_MARKER);
		const contentType = parts[0].split(':')[1];
		const raw = window.atob(parts[1]);
		const rawLength = raw.length;
		const uInt8Array = new Uint8Array(rawLength);

		for (let i = 0; i < rawLength; i += 1) {
			uInt8Array[i] = raw.charCodeAt(i);
		}
		return new Blob([uInt8Array], { type: contentType });
	}
	return undefined;
};

const resizeImage = (imageSrc, maxSize, imageType = 'png', imageName = 'image') => {
	return new Promise((resolve, reject) => {
		const image = new Image();
		image.onload = () => {
			console.log('loaded');
			const canvas = document.createElement('canvas');
			let { width, height } = image;
			height *= maxSize.width / width;
			width = maxSize.width;
			if (height > maxSize.height) {
				height = maxSize.height;
			}
			canvas.width = width;
			canvas.height = height;
			canvas.getContext('2d').drawImage(image, 0, 0, width, height);
			const dataUrl = canvas.toDataURL(imageType);
			const resizedImage = dataURLToBlob(dataUrl);
			resizedImage.lastModifiedDate = new Date();
			resizedImage.name = imageName;
			resolve(resizedImage);
		};
		image.onerror = (error) => {
			reject(error);
		};
		image.src = imageSrc;
	});
};

const dataURLToFile = (dataURI, name) => {
	const img = dataURLToBlob(dataURI);
	return new File([img], name || `img${dataURI.length}${Math.floor(Math.random() * 100)}`);
};

const readImageFile = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			resolve(reader.result);
		};
		reader.onerror = (err) => {
			reject(err);
		};
		reader.readAsDataURL(file);
	});
};

export const readRemoteImageAsBase64 = (url) => {
	return new Promise((resolve, reject) => {
		const request = new XMLHttpRequest();
		request.open('GET', url, true);
		request.responseType = 'blob';
		request.onload = function () {
			const reader = new FileReader();
			reader.readAsDataURL(request.response);
			reader.onload = function (e) {
				resolve(e.target.result);
			};
			reader.onerror = (err) => {
				reject(err);
			};
		};
		request.onerror = (err) => {
			reject(err);
		};
		request.send();
	});
};

export {
	resizeImage,
	readImageFile,
	dataURLToBlob,
	doGetSignedUrl,
	_DataTransfer,
	dataURLToFile,
	checkImageIsLoaded,
};
